<style lang="scss">
	#warp_subs_from_s{
		display: flex;
		justify-content: space-between;
		.ant-col{
			margin-bottom: -.5rem;
		}
		.ant-input-disabled{
			color: #000;
			background-color: #fff;
			// border: 0;
		}
	}
	.mycol_div6{
		width: 24%;
		display: inline-block;
	}
	.id_nav{
		display: inline-block;
	}
	.id_nav .mydiv{
		width: 48%;
		margin-top: .5rem;
		display: inline-block;
	}
	#text_title{
		font-size: .8rem;
		color: #000;
		text-align: center;
		vertical-align: bottom;
		border-bottom: 1px solid #d8d8d8;
		border-top: 1px solid #d8d8d8;
		margin-bottom: 1rem;
		padding: .5rem 0;
		display: flex;
		justify-content: space-between;
	}
	#text_title>div{
		width: 24.4%;
		display: inline-block;
	}
	#text_title>div>div{
		width: 45%;
		display: inline-block;
	}
	
	#warps_look .btnimg{
		border: 1px solid #d8d8d8;
		text-align: center;
		width: 100%;
		margin-right: .5rem;
		display: inline-block;
		height: 1.8rem;
		position: relative;
		top: 0.1rem;
		cursor: pointer;
	}
	
	#warps_look .imgbtn{
		width: 1rem;
	}
	
	#warps_look, #warp_subs {
		.warp_rightz {
			.ant-input {
				padding-right: 1rem !important;
			}
		}

		.ant-btn:hover,
		.ant-btn:focus {
			color: #0c8b96 !important;
			background-color: #fff;
			border-color: #0c8b96 !important;
		}
		.ant-form label {
			font-size: .8rem;
		}

		.warp_a {
			width: 1.95rem;
			text-align: center;
			margin: 0;
			display: inline-block;
		}

		.texright {
			text-align: left;
			margin-left: 4%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 85% !important;
			.wart-t {
				width: 100%;
			}
		}

		.warp_long {
			width: 48%;
			display: inline-block;

			.ant-form-item-label {
				width: 20% !important;
			}

			.ant-form-item-control-wrapper {
				width: 80% !important;
				font-size: .8rem;
				color: #000;
			}
			.iconeye{
				position: relative;
				// right: -16.5rem;
				font-size: .8rem;
				top: .6rem;
			} 
		}
		.formItem {
			.ant-form-item-children {
				display: flex;
				justify-content: space-between;
			}
		}

		.ant-form-item {
			margin-bottom: .6rem;
			width: 100% !important;
			margin-right: 0;
		}

		.landen {
			.ant-form-item-label {
				white-space: pre-wrap;
				line-height: .8rem;
				padding: 0.5rem 0;
			}

			.ant-form label {
				font-size: .6rem;
			}
		}
	}

	#warps_look .ant-form-explain {
		min-height: 0;
		display: none;
	}

	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#warps_look .nonebor {
		position: relative;
		top: 3rem;

		div {
			display: inline-block;
			padding: 0 6px;
			cursor: pointer;
		}
	}
	.iconeye:hover{
		color: #0c8b97;
		cursor: pointer;
	}
</style>
<template>
	<div>
		<a-modal id='warps_look' width='48rem' v-model="visible" on-ok="handleOk1"
			:dialog-style="{ top: '15vh' }"
			@cancel="handleCancel(0)" v-dragModal :footer="null"  :keyboard='false' :maskClosable='false'>
			<div class='mark-file' style="z-index: 2;">
				<div style="width: 46rem;">
					{{lang.ipomessage}}
				</div>
			</div>
			<div solt='title'></div>
			<div class='nonebor' style="z-index: 100;">
				<div @click='england = "cn"' :style='england == "cn"?"color:#0c8b96":""' title='中文'>中文</div>
				<div @click='england = "en"' :style='england == "en"?"color:#0c8b96":""' title='EN'
					style="border-left: 1px solid #999;margin-right: .7rem;">EN</div>
			</div>
			<div class='body_lis' :class="england=='en'?'landen':''"
				style="z-index: 1;width: 46rem;position: relative;top: 1.45rem;padding-top: 2rem;margin: 0 auto 1.5rem;">
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" 
					hideRequiredMark>
					<div>
						<div class='warp_long'>
							<a-form-model-item v-if='england=="cn"' :label="lang.comname"
								prop='cn_planned_company_name_cn'>
								{{form.cn_planned_company_name_cn}}
							</a-form-model-item>
							<a-form-model-item v-else :label="lang.comname" prop='cn_planned_company_name_en'>
								{{form.cn_planned_company_name_en}}
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label="lang.nature" v-show='england=="cn"'
								prop='cn_planned_industry_name_cn'>
								{{form.cn_planned_industry_name_cn}}
							</a-form-model-item>
							<a-form-model-item v-show='england=="en"' :label="lang.nature"
								prop='cn_planned_industry_name_en'>
								{{form.cn_planned_industry_name_en}}
							</a-form-model-item>
						</div>
						<div class='warp_long '>
							<a-form-model-item :label="lang.market" prop='plates_cn'>
								{{admintypeArrs[form.plates_cn]}}
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label="lang.status" prop='status_cn'>
								{{admintypeArr[form.status_cn]}}
							</a-form-model-item>
						</div>
						<div class='warp_long '>
							<a-form-model-item :label="lang.subdata" prop='delivery_date'>
								{{form.delivery_date}}
							</a-form-model-item>
						</div>
						<div  class='warp_long texright'>
							<a-form-model-item :label="lang.profile" prop='info'>
								<a-popover placement="bottom" :destroyTooltipOnHide="true" trigger="click"
								:overlayStyle="{width:'calc(25rem)'}"
									:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
									<template slot="content">{{form.info}}</template>
										<img :src="require('@/image/newexcel.png')" alt="" class='imgbtn'
										style='position: relative;top: -0.1rem;'>
								</a-popover>
							</a-form-model-item>
						</div>
						<div class='warp_long'>
							<a-form-model-item v-if='england=="cn"' :label="lang.stockname"
								:prop='form.status_cn!==0?"stockname":""'>
								{{form.stockname}}
							</a-form-model-item>
							<a-form-model-item v-else :label="lang.stockname"
								:prop='form.status_cn!==0?"stockname_en":""'>
								{{form.stockname_en}}
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label="lang.stockcode" :prop='form.status_cn!==0?"stockcode":""'>
								{{form.stockcode}}
							</a-form-model-item>
						</div>
						<div class='warp_long'>
							<a-form-model-item :label="lang.sponsor" prop='baojianr'>
									{{form.baojianr}}
								<a-popover :visible="visibles" placement="top" trigger="click"
									:destroyTooltipOnHide="true" :overlayStyle="{width:'calc(25rem)'}"
									@visibleChange="moreEvent()"
									:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
									<template slot="content">
										<div>
											<div id='on-center'>
												{{form.baojianr}}
											</div>
										</div>
									</template>
								</a-popover>
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label='lang.ldata' prop='listingdate'>
								{{form.listingdate}}
							</a-form-model-item>
						</div>
						<div class='warp_long '>
							<a-form-model-item :label='lang.efee' prop='entryfee'>
								{{form.entryfee}}
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label='lang.Board' prop='pergshu'>
								{{form.pergshu}}
							</a-form-model-item>
						</div>
						<div class='warp_long '>
							<a-form-model-item :label="lang.price" class="formItem" prop='offer_price_l'>
							{{form.offer_price_l}}
							<div class='warp_a' v-if='form.offer_price_l||form.offer_price_h'>~</div>
							{{form.offer_price_h}}
						</a-form-model-item>
						</div>
						<div class='warp_long texright'>
						<a-form-model-item :label="lang.Period" class="formItem" prop='application_open'>
							{{form.application_open}}
							<div class='warp_a' v-if='form.application_open||form.application_close'>~</div>
							{{form.application_close}}
						</a-form-model-item>
					</div>
					<div class='warp_long '>
						<a-form-model-item :label="lang.grey" prop='anpantime'>
							{{form.anpantime}}
						</a-form-model-item>
					</div>
						<div class='warp_long texright'>
							<a-form-model-item :label="lang.rate" prop='multiple'>
								{{form.multiple}}
							</a-form-model-item>
						</div>
						<div class='warp_long '>
							<a-form-model-item :label="lang.Prospectus" prop='linkaddress'>
								<div style="justify-content: space-between;display: flex;">
									<span style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;width: 90%;position: relative;-webkit-box-orient: vertical;">
									{{form.linkaddress}}</span>
									<a-popover placement="bottom" :destroyTooltipOnHide="true" trigger="hover"
									:overlayStyle="{width:'calc(20rem)'}"
										:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
										<template slot="content">{{form.linkaddress}}</template>
											<a-icon type="eye" class='iconeye' style='height: 1rem;'/>
									</a-popover>
								</div>
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label="lang.jeb" prop='application_open'>
							<!-- <div class="btnimg" @click='visibleadd = true'> -->
							<!-- <img :src="require('@/image/newadd.png')" alt="" class='imgbtn'
								style='position: relative;top: -0.2rem;'> -->
								<img :src="require('@/image/newexcel.png')" alt="" class='imgbtn'
								style='position: relative;top: -0.1rem;' @click='visibleadd = true'>
								<!-- </div> -->
								
							</a-form-model-item>
						</div>
						<div class='warp_long '>
							<a-form-model-item :label="lang.dkbl" prop='application_open'>
								{{form.loan_ratio}}<span v-if='form.loan_ratio'>%</span> 
							</a-form-model-item>
						</div>
						<div class='warp_long texright'>
							<a-form-model-item :label="lang.rs" >
								{{form.loan_days}}
							</a-form-model-item>
						</div>
						
						<div class='warp_long '>
							<a-form-model-item :label="lang.lx">
								{{form.gain}}<span v-if='form.loan_days'>%</span> 
							</a-form-model-item>
						</div>
					</div>
				</a-form-model>
				<a-modal v-show='!ishand' id='warp_subs' width='75rem' v-model="visibleadd" on-ok="handleOk1"
				 @cancel="visibleadd = false"  :dialog-style="{ top: '7vh' }"
				 v-dragModal :footer="null" :keyboard='false' :maskClosable='false'>
								<div class='mark-file'style="z-index: 2;">
									<div style="width: 73rem;">
										<!-- {{lang.jeb}} -->
										申請認購的香港發售股份數目及應繳股款
									</div>
								</div>
							<div solt='title'></div>
							<div class='body_lis' :class="england=='en'?'landen':''" 
							style="z-index: 1;width: 73rem;position: relative;top: 1.45rem;padding-top: 2rem;margin: 0 auto 1.5rem;">
							<div id='text_title' style='width: 100%;margin: 0 auto .2rem;'>
								<div  v-for='i in 4'>
									<div>
										申請認購的
										<br>香港發售<br>
										股份數目
									</div>
									<div>
										<br>
										申請時<br>
										應繳款項
									</div>
								</div>
							</div>
							<div id='warp_subs_from_s'>
								<div class='mycol_div6' v-for='(v,i) in fouten'>
									<div class='id_nav' v-for='(k,ind) in v' :key='ind+"223366"'
									 style='width: 100%;display: flex;justify-content: space-between;'>
										<div class='mydiv'>
											<a-input v-model="k.pricekey" class='warp_width' disabled></a-input>
										</div>
										<div class='mydiv'>
											<a-input v-model="k.priceval" class='warp_width' disabled></a-input>
										</div>
									</div>
								</div>
							</div>
								<div class='warp_button' style="margin-top: 2rem;display: flex;justify-content: space-between;">
									<div class='six_div'>
											<div>
												公司名稱: {{form.cn_planned_company_name_cn}}
											</div>
											<div>
												招股價: 
												<span v-if='form.offer_price_h'>{{form.offer_price_h}}</span>
												<span v-else-if='form.offer_price_l'>{{form.offer_price_l}}</span>
											</div>
										<br>
										<div>
											交易佣金: {{ServiceCharge.commission}}
											</div><div>
											交易微費: {{ServiceCharge.Micro_fee}}
											</div><div>
											交易費:	  {{ServiceCharge.Transaction_fee}}
											</div><div>
											財匯局交易徵費:	 {{ServiceCharge.Matimp}}  
										</div>
									</div>
								<!-- 	<button type="button" class="qdBtn" @click="visibleadd = false" v-if='ipoAdmin'>
										{{lang.confirm}}
										</button> -->
								</div>
							</div>
						</a-modal>
			</div>
		</a-modal>
	</div>
</template>
<script>
	export default {
		props: ['island', 'record' ,'missionflag'],
		components: {},
		data() {
			return {
				ServiceCharge:{
					commission:'1%',
					Micro_fee:'0.0027%',
					Transaction_fee:'0.00565%',
					Matimp:'0.00015%',
				},
				ishand:false,
				admintypeArrs: ['主板','創業板'],
				admintypeArr: ['處理中','待上市','已上市'],
				fouten:{
					'12':[],
					'24':[],
					'36':[],
					'48':[],
				},
				visibleadd: false,
				visibles: false,
				england: 'cn',
				lang: '',
				visible: this.island,
				form: {
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					linkaddress: ''
					// "adminid": "", // 錄入人唯一標識
				},
			};
		},
		watch: {
			england: {
				immediate: true,
				handler(ev) {
					this.lang = this.england == 'cn' ? this.$big5.sub : this.$eng.sub
				},
			}
		},
		created() {
			let _this= this;
			_this.foutenfn()
		},
		mounted() {
			this.handimg()
		},
		methods: {
			foutenfn(){
				for(let key in this.fouten){
					for(let a=0;a<12;a++){
						this.fouten[key].push({
							'pricekey':'',
							'priceval':''
						})
					}
				}
			},
			getdata(){
				this.$ajax({
					method:'post',
					url:this.$api.IpoPrice,
					data:{
						"iposelling_id":this.record.iposelling_id,
						missionflag:this.missionflag
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						for(let key in this.fouten){
							let b=0;
							for(let a=(key-12);a<key*1;a++){
								if(res.data.pricelist[a]){
									res.data.pricelist[a]['pricekey'] = this.numgeshihua(res.data.pricelist[a]['pricekey'],0)
									res.data.pricelist[a]['priceval'] = this.numgeshihua(res.data.pricelist[a]['priceval'],2)
									this.fouten[key][b] = res.data.pricelist[a]
								}
								b++
							}
						}
					}
				})
			},
			numgeshihua(ins,c, d, t){
			var n = ins, 
			    c = isNaN(c = Math.abs(c)) ? 2 : c, 
			    d = d == undefined ? "." : d, 
			    t = t == undefined ? "," : t, 
			    s = n < 0 ? "-" : "", 
			    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
			    j = (j = i.length) > 3 ? j % 3 : 0;
			   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
			 },
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getIpoSellingById,
					data: {
						"iposelling_id": this.record.iposelling_id,
						missionflag:this.missionflag
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.form = res.data.iposelling
						this.getdata()
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			//彈出前操作
			moreEvent() {
				this.visibles = !this.visibles
				this.$set(this.form, 'baojianrval', JSON.parse(JSON.stringify(this.form.baojianr)))
			},
		
			//前后一天
			getNextDate(date, day) {
				var dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			},
			handleOk1() {},
			handleCancel(ev) {
				this.$emit('child', 0)
			},

		},
	};
</script>